<template>
    <div class="web_google_welcome">
        <div class="web_google_welcome_text">{{ $t('language.imageSaver.webGoogleBlankText') }}</div>
        <img draggable="false" src="../../assets/images/imageSaver/web_google_welcome.png" />
    </div>
</template>

<script>
export default {
    name: "imageSaverWebGoogleWelcome",
};
</script>

<style scoped>
.web_google_welcome {
    width: 1000px;
    margin: 0 auto;
    text-align: center;
}
.web_google_welcome_text {
    font-family: "Microsoft YaHei UI";
    font-size: 18px;
    color: #333333;
    line-height: 22px;
    margin: 76px auto 50px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/image_saver_web_google_welcome.vue